import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { useIntl } from 'gatsby-plugin-react-intl'
import * as styles from './Demo.module.scss'
import DesktopWebm from './assets/race-desktop.webm'
import DesktopMp4 from './assets/race-desktop.mp4'
import MobileWebm from './assets/race-mobile.webm'
import MobileMp4 from './assets/race-mobile.mp4'
import BookIcon from './assets/book.svg'

const Demo: React.FC = () => {
  const t = useIntl()

  return (
    <div className={styles.container}>
      <div className={styles.mascot}>
        <StaticImage
          src='./assets/blobby-educated.png'
          alt=''
          width={145}
          height={225}
        />
      </div>
      <div className={styles.titleBar}>
        <div className={styles.titleBarButtons}>
          <div className={styles.titleBarButton} />
          <div className={styles.titleBarButton} />
          <div className={styles.titleBarButton} />
        </div>
        <div className={styles.titleBarTitle}>
          <BookIcon />
          <span>
            {t.formatMessage({ id: 'demo.titleBar' })}
          </span>
        </div>
      </div>
      <div className={styles.videoWrapper}>
        <video
          id='desktop-video'
          className={styles.video}
          loop
          autoPlay
          muted
          playsInline
        >
          <source
            src={DesktopWebm}
            type='video/webm'
          />
          <source
            src={DesktopMp4}
            type='video/mp4'
          />

        </video>
        <video
          id='mobile-video'
          className={styles.mobileVideo}
          loop
          autoPlay
          muted
          playsInline
        >
          <source
            src={MobileWebm}
            type='video/webm'
          />
          <source
            src={MobileMp4}
            type='video/mp4'
          />

        </video>
      </div>
    </div>
  )
}

export default Demo
